<template lang="html">
  <div class="card-invite card-user">
    <div class="card-invite-form">
      <input-component
        type="text-btn"
        icon="arrow-right"
        label=""
        btntype="btn-success"
        placeholder="Filtro"
        @inputactionclick="buscarComFiltro"
        @inputactionenter="buscarComFiltro"
      />
    </div>

    <div class="col-12 card-body" v-if="!ecommerces.length">
          <strong>Nenhum registro encontrado.</strong>
    </div>

    <table class="table table-hover table-responsive-md">
      <tbody>
      <tr v-for="ecommerce in ecommerces" v-bind:key="ecommerce.id" class="d-flex"
      v-bind:class="[ecommerce.enable ? '': 'disable']"
      >
        <td scope="row" class="col-3">
          <div class="subtitle" v-if="ecommerce.name"><strong>{{ ecommerce.name }}</strong></div>
          <div class="subtitle" v-if="ecommerce.cnpj">
            CNPJ {{ ecommerce.cnpj | formatCnpj }}
          </div>
        </td>
        <td class="col-3">
          <div class="subtitle" v-if="ecommerce.branch">
            Número banco: {{ ecommerce.bankCode }}
          </div>
          <div class="subtitle" v-if="ecommerce.bankCode">
            Agência: {{ ecommerce.branch }}
          </div>
        </td>
        <td class="col-2">
          <div class="subtitle" v-if="ecommerce.accountNumber">
            Nº conta: {{ ecommerce.accountNumber }}
          </div>
          <div class="subtitle" v-if="ecommerce.accountType">
            Tipo de conta: {{ ecommerce.accountType }}
          </div>
        </td>
        <td class="col-3">
          <div class="subtitle" v-if="ecommerce.nameBankAccount">
            {{ ecommerce.nameBankAccount }}
          </div>
          <div v-if="ecommerce.conciliationReportLink">
            <a :href="ecommerce.conciliationReportLink" target="_blank">Link pagamentos</a>
          </div>
        </td>
        <td class="col-1" style="display:flex; align-items: center;">
          <router-link :to="{name: 'new e-commerce', params: { ecommerceId: ecommerce.id }}">
            <i class="fas fa fa-edit fa-3x" title="Editar"></i>
          </router-link>
        </td>
      </tr>
      </tbody>
    </table>
    <b-pagination size="md" align="center" :total-rows="total" v-model="currentPage" :per-page="max" @change="fetchData">
    </b-pagination>
  </div>
</template>

<script>
import Button from '../button/Button.vue'
import Input from '../form/Input.vue'

export default {
  props: {
    'ecommerce': {
      default: true
    },
    'refreshList': {
    }
  },
  components: {
    'input-component': Input,
    'button-component': Button
  },
  data () {
    return {
      name: null,
      ecommerces: [],
      currentPage: 1,
      max: 10,
      total: 0
    }
  },
  mounted () {
    this.fetchData(1)
  },
  methods: {
    fetchData: function (val) {
      var page = val || this.currentPage
      this.$http.get('api/sellers/search', {params: {offset: this.max * (page - 1), max: this.max, name: this.name}})
        .then(function (res) {
          this.ecommerces = res.data.list
          this.total = res.data.sellerCount
        })
        .catch(function (res) {
          console.log('Error')
          console.log(res)
        })
    },
    buscarComFiltro: function (filtro, item) {
      console.log(filtro)
      this.name = filtro
      this.currentPage = 1
      this.fetchData()
    }
  },
  watch: {
    'refreshList' () {
      this.fetchData()
    }
  },
  filters: {
    formatCnpj: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5')
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../assets/scss/variaveis.scss";
  @import "../../../assets/scss/mixins.scss";
  @import "../../../assets/scss/card.scss";
  .card-user {
    .avatar {
      width: 40px;
    }
    .card-invite-body {
      top: 102px;
    }
  }
  .img-profile {
    float: left;
    margin-right:1rem;
  }
  .disable {
    opacity: 0.45
  }
</style>



// WEBPACK FOOTER //
// src/components/partial/ecommerces/EcommerceList.vue